import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { UserProfileModel } from '@app/core/models/users/user-profile.model';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit, OnDestroy {

  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  dispatcherUrl: string = '/dispatcher';

  constructor(private router: Router,
    private authenticationInfo: AuthenticationInfoService,
    ) { }


  ngOnInit() {
    this.authenticationInfo.userProfileLoaded$.pipe(
      takeUntil(this.unsubscribe$),
      filter(userProfile => !_.isNil(userProfile)))
      .subscribe((userProfile: UserProfileModel) => {
        // if (userProfile.hasAnyGrantAccess && this.authService.IsTokenValid) {
          this.router.navigate([this.dispatcherUrl]);
          return;
        // }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
